import React from "react";
import useFlightCardBadgesListController from "./useFlightCardBadgesList.controller.js";
import { Stack } from "@bookingcom/bui-react";
import { FlightCardBadge } from "./FlightCardBadge.js";
const FlightCardBadgesList = ({ flight }) => {
    const badgesList = useFlightCardBadgesListController(flight);
    if (badgesList.length === 0) {
        return undefined;
    }
    return (React.createElement(Stack, { direction: "row", gap: 1, alignItems: "center" }, badgesList.map((badge) => {
        return React.createElement(FlightCardBadge, { key: badge.key, ...badge });
    })));
};
export default FlightCardBadgesList;
